const StateJS = require('@steelbreeze/state');
const EventEmitter = require('events').EventEmitter;
const Enum = require('./enums');
const Event = require('./events');

/*
 * Definition for type : KeepAliveController
 */

function KeepAliveController(name, root) {
  this.bus = (root === null) ? new EventEmitter() : root.bus;
  this.name = name;
  this.root = (root === null) ? this : root;
  this.ready = false;

  this.build(name);
}

KeepAliveController.prototype.build = function (session) {
  /* State machine (states and regions) */
  /* Building root component */
  this._statemachine = new StateJS.State('default_statemachine');
  const _initial_KeepAliveController = new StateJS.PseudoState('_initial', this._statemachine, StateJS.PseudoStateKind.Initial);
  const KeepAliveController_null_Idle = new StateJS.State('Idle', this._statemachine).entry(() => {
    this.bus.emit('keepAliveButton', new Event.Hide_ButtonMsg(this.name, 'keepAliveButton'));
  });
  const KeepAliveController_null_Normal = new StateJS.State('Normal', this._statemachine).entry(() => {
    const timeLeft_var = this.KeepAliveController_currentTTL_var * 1000;
    let waitDurationBeforeWarning_var = timeLeft_var - this.KeepAliveController_timeLeftBeforeWarning_var;
    if (waitDurationBeforeWarning_var < 1) {
      waitDurationBeforeWarning_var = 1;
    } else {
      this.bus.emit('keepAliveButton', new Event.Hide_ButtonMsg(this.name, 'keepAliveButton'));
    }
    this.bus.emit('timer', new Event.Timer_start_TimerMsgs(this.name, 'timer', this.KeepAliveController_shortTimeLeftTimerId_var, waitDurationBeforeWarning_var));
  }).exit(() => {
    this.bus.emit('timer', new Event.Timer_cancel_TimerMsgs(this.name, 'timer', this.KeepAliveController_shortTimeLeftTimerId_var));
  });
  const KeepAliveController_null_Warning = new StateJS.State('Warning', this._statemachine).entry(() => {
    this.bus.emit('keepAliveButton', new Event.Show_ButtonMsg(this.name, 'keepAliveButton'));
    this.bus.emit('keepalive', new Event.KeepAliveWarning_KeepAliveControllerMsg(this.name, 'keepalive', true));
  }).exit(() => {
    this.bus.emit('keepalive', new Event.KeepAliveWarning_KeepAliveControllerMsg(this.name, 'keepalive', false));
  });
  const KeepAliveController_null_Warning_WarningTickTack = new StateJS.State('WarningTickTack', KeepAliveController_null_Warning).entry(() => {
    this.KeepAliveController_null_Warning_WarningTickTack_secondsLeft_var = this.computeSecondsLeft();
    this.onTTLChange(this.KeepAliveController_null_Warning_WarningTickTack_secondsLeft_var);
    this.bus.emit('timer', new Event.Timer_start_TimerMsgs(this.name, 'timer', this.KeepAliveController_tickTackTimerId_var, 1000));
  }).exit(() => {
    this.bus.emit('timer', new Event.Timer_cancel_TimerMsgs(this.name, 'timer', this.KeepAliveController_tickTackTimerId_var));
  });
  const KeepAliveController_null_Warning_WarningEnd = new StateJS.State('WarningEnd', KeepAliveController_null_Warning).entry(() => {
    this.bus.emit('videoControl', new Event.Stop_VideoControllerMsg(this.name, 'videoControl'));
  });
  const _initial_KeepAliveController_null_Warning = new StateJS.PseudoState('_initial', KeepAliveController_null_Warning, StateJS.PseudoStateKind.Initial);
  _initial_KeepAliveController_null_Warning.to(KeepAliveController_null_Warning_WarningTickTack);
  _initial_KeepAliveController.to(KeepAliveController_null_Idle);
  KeepAliveController_null_Normal.to(KeepAliveController_null_Warning).on(Event.Timer_timeout_TimerMsgs).when((timer_timeout) => timer_timeout.port === 'timer' && timer_timeout.type === 'timer_timeout' && (timer_timeout.id === this.KeepAliveController_shortTimeLeftTimerId_var));
  KeepAliveController_null_Warning_WarningTickTack.to(KeepAliveController_null_Warning_WarningTickTack).on(Event.Timer_timeout_TimerMsgs).when((timer_timeout) => timer_timeout.port === 'timer' && timer_timeout.type === 'timer_timeout' && (timer_timeout.id === this.KeepAliveController_tickTackTimerId_var && this.KeepAliveController_null_Warning_WarningTickTack_secondsLeft_var > 0));
  KeepAliveController_null_Warning_WarningTickTack.to(KeepAliveController_null_Warning_WarningEnd).on(Event.Timer_timeout_TimerMsgs).when((timer_timeout) => timer_timeout.port === 'timer' && timer_timeout.type === 'timer_timeout' && (timer_timeout.id === this.KeepAliveController_tickTackTimerId_var && this.KeepAliveController_null_Warning_WarningTickTack_secondsLeft_var <= 0));
  KeepAliveController_null_Normal.to(KeepAliveController_null_Normal).on(Event.StreamTtl_ApiDigitaltTilsynMsg).when((streamTtl) => streamTtl.port === 'api' && streamTtl.type === 'streamTtl').effect((streamTtl) => {
    this.updateCurrent(streamTtl.ttl, streamTtl.streamId, streamTtl.cameraId);
  });
  KeepAliveController_null_Warning.to(KeepAliveController_null_Normal).on(Event.StreamTtl_ApiDigitaltTilsynMsg).when((streamTtl) => streamTtl.port === 'api' && streamTtl.type === 'streamTtl').effect((streamTtl) => {
    this.updateCurrent(streamTtl.ttl, streamTtl.streamId, streamTtl.cameraId);
  });
  KeepAliveController_null_Idle.on(Event.StreamStarted).when((streamStarted) => streamStarted.port === 'api' && streamStarted.type === 'streamStarted').effect((streamStarted) => {
    this.updateCurrent(streamStarted.ttl, streamStarted.streamId, streamStarted.cameraId);
  });
  KeepAliveController_null_Normal.on(Event.KeepAlive).when((keepAlive) => keepAlive.port === 'keepalive' && keepAlive.type === 'keepAlive').effect((keepAlive) => {
    this.bus.emit('api', new Event.KeepStreamAlive_ApiDigitaltTilsynMsg(this.name, 'api', this.KeepAliveController_currentCameraId_var, this.KeepAliveController_currentStreamId_var, this.KeepAliveController_defaultKeepAliveTtl_var));
  });
  KeepAliveController_null_Warning.on(Event.KeepAlive).when((keepAlive) => keepAlive.port === 'keepalive' && keepAlive.type === 'keepAlive').effect((keepAlive) => {
    this.bus.emit('api', new Event.KeepStreamAlive_ApiDigitaltTilsynMsg(this.name, 'api', this.KeepAliveController_currentCameraId_var, this.KeepAliveController_currentStreamId_var, this.KeepAliveController_defaultKeepAliveTtl_var));
  });
  KeepAliveController_null_Normal.to(KeepAliveController_null_Idle).on(Event.Stopped_VideoControllerMsg).when((stopped) => stopped.port === 'videoControl' && stopped.type === 'stopped');
  KeepAliveController_null_Warning.to(KeepAliveController_null_Idle).on(Event.Stopped_VideoControllerMsg).when((stopped) => stopped.port === 'videoControl' && stopped.type === 'stopped');
  KeepAliveController_null_Idle.to(KeepAliveController_null_Normal).on(Event.Playing_VideoControllerMsg).when((playing) => playing.port === 'videoControl' && playing.type === 'playing');
};
KeepAliveController.prototype.getCurrentTime = function () {
  return Date.now();
};

KeepAliveController.prototype.updateCurrent = function (KeepAliveController_updateCurrent_ttl_var, KeepAliveController_updateCurrent_streamId_var, KeepAliveController_updateCurrent_cameraId_var) {
  this.KeepAliveController_currentTTL_var = KeepAliveController_updateCurrent_ttl_var;
  this.KeepAliveController_currentStreamId_var = KeepAliveController_updateCurrent_streamId_var;
  this.KeepAliveController_currentCameraId_var = KeepAliveController_updateCurrent_cameraId_var;
  this.KeepAliveController_timeWhenCurrentTTLIsReceived_var = this.getCurrentTime();
};

KeepAliveController.prototype.computeSecondsLeft = function () {
  const now_var = this.getCurrentTime();
  const diff_var = (this.KeepAliveController_currentTTL_var * 1000 - now_var + this.KeepAliveController_timeWhenCurrentTTLIsReceived_var) / 1000;
  return (Math.max(0, Math.round(diff_var)));
};

KeepAliveController.prototype.onTTLChange = function (KeepAliveController_onTTLChange_ttl_var) {};

KeepAliveController.prototype._stop = function () {
  this.root = null;
  this.ready = false;
  this.stopped = true;
};

KeepAliveController.prototype._delete = function () {
  this._statemachine = null;
  this._null_instance = null;
  this.bus.removeAllListeners();
};

KeepAliveController.prototype._init = function () {
  this._null_instance = new StateJS.Instance('null_instance', this._statemachine);
  this.ready = true;
};

KeepAliveController.prototype._receive = function (msg) {
  if (this.ready) {
    this._null_instance.evaluate(msg);
  } else if (!this.stopped) {
    setTimeout(() => this._receive(msg), 4);
  }
};

KeepAliveController.prototype.toString = function () {
  let result = `instance ${this.name}:${this.constructor.name}\n`;
  result += `\n\ttimeLeftBeforeWarning = ${this.KeepAliveController_timeLeftBeforeWarning_var}`;
  result += `\n\tdefaultKeepAliveTtl = ${this.KeepAliveController_defaultKeepAliveTtl_var}`;
  result += `\n\tcurrentStreamId = ${this.KeepAliveController_currentStreamId_var}`;
  result += `\n\ttimeWhenCurrentTTLIsReceived = ${this.KeepAliveController_timeWhenCurrentTTLIsReceived_var}`;
  result += `\n\tcurrentTTL = ${this.KeepAliveController_currentTTL_var}`;
  result += `\n\ttickTackTimerId = ${this.KeepAliveController_tickTackTimerId_var}`;
  result += `\n\tshortTimeLeftTimerId = ${this.KeepAliveController_shortTimeLeftTimerId_var}`;
  result += `\n\tcurrentCameraId = ${this.KeepAliveController_currentCameraId_var}`;
  result += `\n\tsecondsLeft = ${this.KeepAliveController_null_Warning_WarningTickTack_secondsLeft_var}`;
  result += '';
  return result;
};

module.exports = KeepAliveController;
